import { Offcanvas, Form, Row, Col, Button } from 'react-bootstrap';
import Select from 'react-select';
import Flatpickr from 'react-flatpickr';

/**
 * FilterProjectLogsOffcanvas - Custom Filter for Project Logs
 * 
 * Changes from original FilterTasksOffcanvas:
 * - Removed: Project, Due Date Range
 * - Added: Start Date, End Date (separate fields)
 * - Changed labels: Task List -> Select Department, Assignees -> Assign To, Stage -> Project Status
 * - Reordered fields
 */
const FilterProjectLogsOffcanvas = ({ 
    show, 
    onHide,
    taskNameFilter,
    setTaskNameFilter,
    departmentFilter,
    setDepartmentFilter,
    assignToFilter,
    setAssignToFilter,
    startDateFilter,
    setStartDateFilter,
    endDateFilter,
    setEndDateFilter,
    priorityFilter,
    setPriorityFilter,
    projectStatusFilter,
    setProjectStatusFilter,
    departmentOptions,
    assignToOptions,
    priorityOptions,
    projectStatusOptions,
    onApply,
    onClear
}) => {
    const handleReset = () => {
        setTaskNameFilter('');
        setDepartmentFilter(null);
        setAssignToFilter([]);
        setStartDateFilter(null);
        setEndDateFilter(null);
        setPriorityFilter(null);
        setProjectStatusFilter(null);
        if (onClear) onClear();
    };

    const handleApply = () => {
        if (onApply) onApply();
        onHide();
    };

    return (
        <Offcanvas show={show} onHide={onHide} placement="end">
            <Offcanvas.Header className='px-4 py-3' closeButton>
                <Offcanvas.Title className='display-1'>Filter Tasks</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className='px-4 py-3'>
                <Form>
                    <Row className='gy-2'>
                        {/* Task Name */}
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Task Name</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    value={taskNameFilter}
                                    onChange={(e) => setTaskNameFilter(e.target.value)}
                                    placeholder="Search tasks..."
                                />
                            </Form.Group>
                        </Col>

                        {/* Select Department */}
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Select Department</Form.Label>
                                <Select
                                    value={departmentFilter}
                                    onChange={setDepartmentFilter}
                                    options={departmentOptions}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder="Select department"
                                    isClearable
                                    isMulti
                                />
                            </Form.Group>
                        </Col>

                        {/* Assign To */}
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Assign To</Form.Label>
                                <Select
                                    value={assignToFilter}
                                    onChange={setAssignToFilter}
                                    options={assignToOptions}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder="Select team members"
                                    isClearable
                                    isMulti
                                />
                            </Form.Group>
                        </Col>

                        {/* Start Date */}
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Start Date</Form.Label>
                                <Flatpickr
                                    value={startDateFilter}
                                    onChange={([date]) => setStartDateFilter(date)}
                                    className="form-control"
                                    options={{
                                        dateFormat: 'd M Y',
                                        allowInput: true,
                                        disableMobile: true,
                                        enableTime: false,
                                    }}
                                    placeholder="Select start date"
                                />
                            </Form.Group>
                        </Col>

                        {/* End Date */}
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>End Date</Form.Label>
                                <Flatpickr
                                    value={endDateFilter}
                                    onChange={([date]) => setEndDateFilter(date)}
                                    className="form-control"
                                    options={{
                                        dateFormat: 'd M Y',
                                        minDate: startDateFilter,
                                        allowInput: true,
                                        disableMobile: true,
                                        enableTime: false,
                                    }}
                                    placeholder="Select end date"
                                />
                            </Form.Group>
                        </Col>

                        {/* Priority */}
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Priority</Form.Label>
                                <Select
                                    value={priorityFilter}
                                    onChange={setPriorityFilter}
                                    options={priorityOptions}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder="Select priority"
                                    isClearable
                                    isMulti
                                />
                            </Form.Group>
                        </Col>

                        {/* Project Status */}
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Project Status</Form.Label>
                                <Select
                                    value={projectStatusFilter}
                                    onChange={setProjectStatusFilter}
                                    options={projectStatusOptions}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder="Select status"
                                    isClearable
                                    isMulti
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </Offcanvas.Body>
            <div className="p-3 border-top">
                <div className="d-flex justify-content-between">
                    <Button variant="link" className='text-decoration-none' onClick={handleReset}>
                        Reset
                    </Button>
                    <Button variant="primary" onClick={handleApply}>
                        Apply Filters
                    </Button>
                </div>
            </div>
        </Offcanvas>
    );
};

export default FilterProjectLogsOffcanvas;
